module.exports = __webpack_public_path__ + "img/thumbnail.f9c5087f.svg";